// extracted by mini-css-extract-plugin
export default {"skill":"Skill_skill__Tbcqx","icon":"Skill_icon__N5lEU","skillTitle":"Skill_skillTitle__vighm","description":"Skill_description__VhrzH"};